import styled from 'styled-components';

interface StringMapperProps {
  text?: string;
  letterClassName?: string;
  className?: string;
}

const StringMapper = styled(({ text, letterClassName, className, ...props }: StringMapperProps) => {
  return (
    <span className={className} {...props}>
      {text?.split('').map((letter, index) => (
        <span key={index} className={letterClassName}>
          {letter}
        </span>
      ))}
    </span>
  );
})``;

export default StringMapper;